<template>
  <div class="contents koyoukeiyaku">
    <h2>雇用契約管理画面</h2>

    <div class="container koyoukeiyaku-menu page-menu-items">

      <div class="menu">

        <div class="col-item" v-if="authStore.hasPermission(PermissionConst.KOYOUKEIYAKU_CREATE)">
          <router-link :to="{ name: RouterConst.KOYOUKEIYAKU_EDIT, query: { mode: OptionConst.KOYOUKEIYAKU_EDIT_MODE.CREATE } }">新規作成／追加</router-link>
          <p>新たに入社する社員の雇用契約書の作成、既存社員に対する追加の雇用契約書の作成もこちらから行えます。</p>
        </div>

        <div class="col-item">
          <div class="link" @click="setStore(OptionConst.KEIYAKU_SEARCH_TYPE.FREE)">自由検索</div>
          <p>雇用契約書を検索します。<br>既存の雇用契約書を元にした新規作成や、変更／更新などもこちらから行えます。</p>
        </div>

        <div class="col-item">
          <div class="link" @click="setStore(OptionConst.KEIYAKU_SEARCH_TYPE.KOUSHIN)">更新前一覧</div>
          <p>契約期間終了1ヶ月前の契約書を一覧表示します。</p>
        </div>

        <div class="col-item">
          <div class="link" @click="setStore(OptionConst.KEIYAKU_SEARCH_TYPE.NYUUSYA)">入社スタッフ更新前一覧</div>
          <p>入社後1ヶ月が経過した契約書を一覧表示します。</p>
        </div>

        <div class="col-item">
          <div class="link" @click.stop="setStore(OptionConst.KEIYAKU_SEARCH_TYPE.SYANAI_SYOUNIN)">社内承認中一覧</div>
          <p>社内承認中の雇用契約書を一覧表示します。</p>
        </div>

        <div class="col-item">
          <div class="link" @click="setStore(OptionConst.KEIYAKU_SEARCH_TYPE.HONNIN_SYOUNIN)">本人承認中一覧</div>
          <p>本人承認中の雇用契約書を一覧表示します。</p>
        </div>

        <div class="col-item">
          <div class="link" @click="setStore(OptionConst.KEIYAKU_SEARCH_TYPE.EDIT)">編集中一覧</div>
          <p>編集中の雇用契約書を一覧表示します。</p>
        </div>

      </div><!-- menu -->

    </div><!--container-->

    <div class="button-container">
      <p class="prev-page">
        <router-link :to="{
          name: RouterConst.HOME,
        }">ホーム画面に戻る
        </router-link>
      </p>
    </div><!--button-container-->

  </div><!--contents-->
</template>


<script lang="ts">
import { RouterConst } from '@/const/Router';
import { defineComponent } from 'vue'
import { useKoyouKeiyakuSearchStore } from '@/store/koyoukeiyaku-search'
import OptionConst from '@/const/Option';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/store/auth';
import { PermissionConst } from '@/const/Permission';
// import { useAuthStore } from '@/store/auth';

export default defineComponent({
  setup() {

    // 雇用契約ストア
    const store = useKoyouKeiyakuSearchStore();
    const router = useRouter()

    const authStore = useAuthStore()
    // // ログインユーザーID取得
    // const authStore = useAuthStore();
    // const loginUserId = authStore.user?.user_id;

    // 各種検索ボタン
    const setStore = (type: number) => {
      store.condition.searchType = type;
      router.push({ name: RouterConst.KOYOUKEIYAKU_SEARCH })

    }
    
    return {
      RouterConst,
      OptionConst,
      setStore,
      authStore,
      PermissionConst
    }
  }
})
</script>

<style lang="scss" scoped>
@import "@scss/components/menu-items.scss";
</style>
